import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, inject, viewChild } from '@angular/core';
import {NotificationService} from "../services/notification.service";
import {Router} from "@angular/router";
import {visibilityParams} from "../../../utilities/browser";
import {AuthService} from "../../../auth/auth.service";
import { HttpParams } from "@angular/common/http";

import type {Notification} from "../notification.model";
import type {Subscription} from "rxjs";
import type {Pagination} from "../../../shared/tables/paginator/paginator";
import type {PaginatorAdapter} from "../../../shared/tables/paginator/paginator";

@Component({
    selector: 'app-notification-panel',
    templateUrl: './notification-panel.component.html',
    styleUrls: ['./notification-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NotificationPanelComponent implements OnInit, OnDestroy {
  private notificationService = inject(NotificationService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private authService = inject(AuthService);


  notifications: Notification [] = [];
  sub: Subscription;

  readonly h2 = viewChild<ElementRef<HTMLElement>>('h2');

  hidden: string;
  visibilityChange: string;
  listenerRef: any;
  hasError;

  pagination: Pagination;
  paginatorAdapter: PaginatorAdapter<Notification []>;
  readonly params = new HttpParams({fromObject: {sort: '_id,desc'}});

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const {hidden, visibilityChange} = visibilityParams();
    this.hidden = hidden;
    this.visibilityChange = visibilityChange;
    this.paginatorAdapter = this.notificationService.getNotificationPaginatorAdapter();
  }

  ngOnInit() {
    //this.notificationService.getUnreadCount().subscribe();
    this.sub = this.notificationService.panelOpened.subscribe(opened => {
      if(opened)
        this.getNotifications();
      else {
        this.h2()?.nativeElement.scrollIntoView();
        this.notifications = [];

        this.pagination = null;
        this.cdr.markForCheck();
      }
    });
    //this.listenerRef = this.listener.bind(this);
    //this.subscribeVisibilityChange();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    //window.removeEventListener(this.visibilityChange, this.listenerRef);
  }

  listener() {
    if(this.authService.getLoggedInUser())
      !document[this.hidden] ? this.notificationService.getUnreadCount().subscribe() : null;
  }

  subscribeVisibilityChange() {
    document.addEventListener(this.visibilityChange, this.listenerRef);
  }

  parseNotification(notifications: Notification []) {
    const now = new Date();

    for(let i = 0;i < notifications.length;i++) {
      const date = new Date(notifications[i].updatedAt);
      const timePassedMil = now.getTime() - date.getTime();

      const weeks = timePassedMil / 1000 / 60 / 60 / 24 / 7;
      if(weeks > 1) {
        notifications[i].ago = `${weeks | 0} weeks ago`;
      } else {
        const days = timePassedMil / 1000 / 60 / 60 / 24;
        if(days > 1) {
          notifications[i].ago = `${days | 0} days ago`;
        } else {
          const hours = timePassedMil / 1000 / 60 / 60;
          if(hours > 1) {
            notifications[i].ago = `${hours | 0} hours ago`;
          } else
            notifications[i].ago = `${(timePassedMil  / 1000 / 60) | 0} minutes ago`;
        }
      }

    }
  }

  getNotifications(clear?) {
    if(clear) {
      this.notifications = [];
      this.pagination = null;
    }

    this.paginatorAdapter.getStateless(this.pagination?.nextLink || this.notificationService.basePath).subscribe(({t, pagination}) => {
      this.hasError = false;
      this.pagination = pagination;
      this.parseNotification(t)
      this.notifications = [...this.notifications, ...t];
      this.cdr.markForCheck();
    }, () => this.hasError = true);
  }

  trackByFn(index, item) {
    return item.id;
  }

  open(notification: Notification) {
    let url = notification.data.url.substr(window.location.origin.length +1);
    url = url.substr(0, url.indexOf('?'));
    this.router.navigate([url]).then(() => this.notificationService.closeOnNavigate.next());

    if(notification.clickStatus !== 'READ') {
      this.notificationService.updateClickStatus(notification.ctId, 'READ').subscribe();
    }

    notification.clickStatus = 'READ';
  }

  onScroll() {
    if(this.pagination?.nextLink)
      this.getNotifications();
  }

  markAllRead() {
    this.notificationService.updateClickStatus(null, 'READ').subscribe();

    for (let i = 0; i < this.notifications.length; i++)
      this.notifications[i].clickStatus = 'READ';

  }

}
